module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAUVJREFUWIXllt1RhDAUhb/s+OiMdCAl0IEpYTuQEqzAnw7sQDtw7QA7gApkZ3wXKzg+mN3JYhSI/Dj6vYS5A/ec5JKbgENSIulO0qum41nSFSEk3U8o3Cbf6RrPQAOcBN2Nz5MxxgKsvOBc4gesul/54waOfvDtG1C657O5DVSANcY0AJIyYAOcDk0UW4K9OIAxpgQuYhLFGKh8cc/EZi4DwWWWlM5lIJG0DsSjShD7Ez5IugYegQQ4B/KYRH4rVqSZGIKteBFiSrAFCqB2I4AFMjfGnSk9jtBCku2RZy2p7Mo11MBtxISK0QwMFXf5bB8Di/+EixvotQtiy9CHxVfgVxmoZtStP0Xctmk6+sEY1PKObtMykfLRTlOmoQSK0IXm/9IugQUu2/GROAZegBt3iT1E3/fuscl2uv42zCeY9Vfs75Tvlya1fJDRXWwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_menu_addressbook.png
// module id = 800
// module chunks = 1